import { faLocationArrow } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import es from '../../lang/es';

const ProceedingListMobile = props => {
    //Tomo los props
    const { proceedings, handleSelect } = props;
    //Render
    return (
        <Row className="d-md-none">
            {
                proceedings.map(proceeding => (
                    <Col xs={12} key={`procid${proceeding.procid}`} className="mb-2">
                        <Card>
                            <Card.Header>
                                <Row>
                                    <Col xs={8}>
                                        <strong>{ proceeding.nro_expediente }</strong>
                                    </Col>
                                    <Col xs={4} className="text-right">
                                        <strong>{ proceeding.juzgado.coju }</strong>
                                    </Col>
                                </Row>
                            </Card.Header>
                            <Card.Body>
                                <small><strong>{ proceeding.tipo_proceso }</strong></small>
                                <h5>{ proceeding.caratula }</h5>
                                <Button variant="info" size="sm" onClick={ () => handleSelect(proceeding) }>
                                    <FontAwesomeIcon icon={ faLocationArrow } /> { es.VIEW_HISTORY.toUpperCase() }
                                </Button>
                            </Card.Body>
                        </Card>
                    </Col>
                ))
            }   
        </Row>
    );
};

export default ProceedingListMobile;